import * as Yup from 'yup';
import { useState } from 'react';

import { GridSortModel, GridFilterModel, GridPaginationModel } from '@mui/x-data-grid';

import { useGetAllProducts, useGetFavouritesCollections } from 'src/api/hooks/api-hooks';

interface Props {
  productsPerPage?: number;
}

export type SearchAndFilterFormData = Yup.InferType<typeof FilterSchema>;

const FilterSchema = Yup.object().shape({
  productName: Yup.string(),
  availableFrom: Yup.date()
    .nullable()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Date must be in the future.')
    .typeError('Available On Date needs to be a valid date in the format DD MMMM YYY'),
  // isSmeProducer: Yup.boolean(),
  // isDirectFromProducer: Yup.boolean(),
  producerDistance: Yup.string(),
  distributorSiteId: Yup.string().nullable(),
  allergens: Yup.array().of(Yup.string()),
  categories: Yup.array().of(Yup.string()),
  certifications: Yup.array().of(Yup.string()),
  dietaryLifestyles: Yup.array().of(Yup.string()),
  countryOfOrigin: Yup.array().of(Yup.string()),
  airfreighted: Yup.boolean().optional(),
  productType: Yup.string()
    .nullable()
    .oneOf(['surplus', 'promotion', ''], 'Product type must be either surplus or promotion'),
});

export function useProductsList(props?: Props) {
  const { productsPerPage } = props ?? {};
  const [paginationModel, setPagintionModel] = useState<GridPaginationModel>({
    pageSize: productsPerPage ?? 25,
    page: 0,
  });
  const [filterSearchModel, setFilterSearchModel] = useState<SearchAndFilterFormData>();
  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const [filterModel, setFilterModel] = useState<GridFilterModel>();
  const {
    data: productsResponse,
    isLoading: loadingProducts,
    error,
  } = useGetAllProducts(paginationModel, sortModel[0], filterSearchModel);

  const {
    data: favouritesCollections,
    isLoading: loadingFavouritesCollections,
    error: fetchFavouritesCollectionsError,
  } = useGetFavouritesCollections(1, 100);

  return {
    products: productsResponse?.data ?? [],
    productsTotalCount: productsResponse?.totalRecords,
    productsTotalPages: productsResponse?.totalPages,

    fetchProductsLoading: loadingProducts,
    fetchProductsError: error,

    paginationModel,

    sortModel,
    filterModel,

    fetchProducts: fetch,
    setFilterModel,
    setSortModel,
    setPagintionModel,
    filterSearchModel,
    setFilterSearchModel,

    personalFavouritesCollections: favouritesCollections?.personal,
    favouritesCollectionsData: favouritesCollections,
    fetchloadingFavouritesCollections: loadingFavouritesCollections,
    fetchFavouritesCollectionsError,
  };
}
